<template>
  <nav class="flex items-center justify-center w-full h-16 bg-blue-500">
    <ul class="flex items-center">
      <!-- <li>
        <router-link to="/" exact>Home</router-link>
      </li> -->
      <li>
        <router-link to="/about">About</router-link>
      </li>
      <li>
        <router-link to="/stations">Station Search</router-link>
      </li>
      <li>
        <router-link to="/cops">Rate A Cop</router-link>
      </li>
      <li>
        <router-link to="/">
          <img src="/logo.png" alt="Logo" class="h-16">
        </router-link>
      </li>
      <li>
        <router-link to="/forum">Local Forum</router-link>
      </li>
      <li>
        <router-link to="/legal-services">Legal services</router-link>
      </li>
      <li>
        <router-link to="/profile" v-if="isAuthenticated">Profile</router-link>
        <router-link to="/login" v-else>Login</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },
};
</script>

<style lang="scss" scoped>
ul > li {
  float: left;
  padding: 20px;
  color: #fff;

  a:hover, a.router-link-active {
    color: #4DB1FA;
  }
}
</style>
